import type { ListTimeClocksParams } from 'api/admin/timeClock/listTimeClocks'

const ROOT = 'timeClocks' as const

export const timeClockKeys = {
  all: [ROOT] as const,
  list: (params?: Partial<ListTimeClocksParams>) =>
    [ROOT, 'list', params] as const,
  compumaticPunches: (params?: unknown) =>
    [ROOT, 'compumaticPunches', params] as const,
  compumaticPunchRelated: (punchId: number) =>
    [ROOT, 'compumaticPunchRelated', punchId] as const,
  allForCompany: (companyId: number) =>
    [ROOT, 'allForCompany', companyId] as const,
}
